<template>
  <div class="Alert" :class="{ [`Alert--${level}'`]: !!level }" role="alert">
    <slot></slot> 
  </div>
</template>

<script>
export default {
  props: {
    level: {
      type: String,
      default: ''
    }
  }
}
</script>